module.exports = __webpack_public_path__ + "static/media/favicon.382761ac.ico";